module.exports = __webpack_public_path__ + "img/MIG.5951a0ab.png";